import { PromotionModel, UserModel } from "@/models";
import { siteSettingsService } from "@/services";
import { iPromotionTier } from "@/interfaces/promotions";

export class Promotion {
  /**
   * Whether a user can create a new promotion.
   *
   * @param {User=} user
   * @returns {boolean}
   */
  public static canCreate(user?: UserModel): boolean {
    if (!user) {
      return false;
    }

    const result =
      user.hasPermission("promotions.create") ||
      user.hasPermission("promotions.create-billable");

    return Boolean(result);
  }

  /**
   * Whether a user can manage an existing promotion.
   *
   * @param {PromotionModel=} promotion
   * @param {User=} user
   * @returns {boolean}
   */
  public static canManage(
    user?: UserModel,
    promotion?: PromotionModel,
  ): boolean {
    if (!user) {
      return false;
    }

    // users can manage their own posts
    if (promotion && promotion.data.user_id === user.data.id) {
      return true;
    }

    return user.hasPermission("promotions.manage");
  }

  /**
   * Whether a user can manage the status field of a promotion.
   *
   * @param {UserModel=} user
   * @returns {boolean}
   */
  public static canManageStatus(user?: UserModel): boolean {
    if (!user) {
      return false;
    }
    return user.hasPermission("promotions.manage");
  }

  /**
   * Whether payment is required to create a new promotion.
   *
   * @param {User} user
   * @param {iPromotionTier} tierKey
   * @returns {boolean}
   */
  public static createPaymentRequired(
    user: UserModel,
    tierKey: iPromotionTier,
  ): boolean {
    const tier = siteSettingsService.get("promotion_tiers")[tierKey] || {};
    const userHasPermission =
      user && user.hasPermission("promotions.create-billable");
    const hasPrice = parseFloat(tier.price) > 0;

    return userHasPermission && hasPrice;
  }
}

export default Promotion;
